import { BaseFormFieldTypes, FormField, FormFieldType } from '@/type';

export const isBaseFormFieldType = (field: FormField): field is BaseFormFieldTypes => {
  return ![
    FormFieldType.Divider,
    FormFieldType.Typography,
    FormFieldType.Button,
    FormFieldType.IconButton,
    FormFieldType.Accordion,
  ].includes(field.type);
};
